import { create } from 'zustand'

const EMPTY_FILTER = { peopleFilters: undefined, filterLogic: undefined, quickFilter: undefined };

const useFilterStore = create((set) => ({
    filters: {},
    setActiveFilter: (filterId, { peopleFilters, filterLogic }) => set((state) => ({
        filters: { ...state.filters, [filterId]: { ...state.filters[filterId], peopleFilters, filterLogic } }
    })),
    setQuickFilter: (filterId, { quickFilter, filterLogic, peopleFilters }) => set((state) => ({
        filters: { ...state.filters, [filterId]: { quickFilter, filterLogic, peopleFilters } }
    })),
    clearFilters: (filterId) => set((state) => ({
        filters: { ...state.filters, [filterId]: { peopleFilters: undefined, filterLogic: undefined, quickFilter: undefined } }
    })),
}))

export const useFilter = (filterId) =>
    useFilterStore((state) => state.filters[filterId] ?? EMPTY_FILTER);

export default useFilterStore